import { Spinner } from './Spinner.jsx';

/**
 * DB-5: dashboard figures are never cached client-side, so this renders a
 * pending state rather than a stale previous value. A stale number here is money
 * reported wrongly.
 */
export function StatCard({ label, value, hint, loading = false, icon: Icon, tone = 'default' }) {
  return (
    <div className="panel lift p-4">
      <div className="flex items-start justify-between gap-3">
        <p className="stat-tile-label">{label}</p>
        {Icon && (
          <span className="stat-tile-icon" aria-hidden="true">
            <Icon className="h-3.5 w-3.5" />
          </span>
        )}
      </div>

      <div className="mt-2.5 flex min-h-[2rem] items-baseline">
        {loading ? (
          <Spinner size="md" className="text-faint" label={`Loading ${label}`} />
        ) : (
          <span
            className={`tabular text-2xl font-semibold tracking-tight ${
              tone === 'danger' ? 'text-red-600' : 'text-ink'
            }`}
          >
            {value}
          </span>
        )}
      </div>

      {hint && <p className="mt-1 text-xs text-muted">{hint}</p>}
    </div>
  );
}

export default StatCard;
